/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Related } from './Related';
import {
    RelatedFromJSON,
    RelatedFromJSONTyped,
    RelatedToJSON,
} from './Related';
import type { ReplyComment } from './ReplyComment';
import {
    ReplyCommentFromJSON,
    ReplyCommentFromJSONTyped,
    ReplyCommentToJSON,
} from './ReplyComment';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface CommentRepliesResponse
 */
export interface CommentRepliesResponse {
    /**
     * 
     * @type {number}
     * @memberof CommentRepliesResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof CommentRepliesResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof CommentRepliesResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof CommentRepliesResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof CommentRepliesResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof CommentRepliesResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof CommentRepliesResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<ReplyComment>}
     * @memberof CommentRepliesResponse
     */
    data?: Array<ReplyComment>;
    /**
     * 
     * @type {Related}
     * @memberof CommentRepliesResponse
     */
    related?: Related;
}

/**
 * Check if a given object implements the CommentRepliesResponse interface.
 */
export function instanceOfCommentRepliesResponse(value: object): value is CommentRepliesResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function CommentRepliesResponseFromJSON(json: any): CommentRepliesResponse {
    return CommentRepliesResponseFromJSONTyped(json, false);
}

export function CommentRepliesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentRepliesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ReplyCommentFromJSON)),
        'related': !exists(json, 'related') ? undefined : RelatedFromJSON(json['related']),
    };
}

export function CommentRepliesResponseToJSON(value?: CommentRepliesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ReplyCommentToJSON)),
        'related': RelatedToJSON(value.related),
    };
}

